import * as React from "react";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SearchIcon from "@mui/icons-material/Search";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import PrintIcon from "@mui/icons-material/Print";
import axios from "axios";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import HOST_URL from '../../../utils/Url';
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import {
  GridColDef,
} from "@mui/x-data-grid";
import Switch from "@mui/material/Switch";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import api from "../../../utils/Url";
import DataGrids from "../../../utils/Datagrids";
import dayjs from "dayjs";
import api2 from "../../../utils/Url2";

interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}

export default function VehicleType() {
  const [item, setItem] = useState([]);
  const [columns, setColumns] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  let navigate = useNavigate();
  const { t } = useTranslation();
  useEffect(() => {
    fetchvehicleData();
  }, [isLoading]);
  const routeChangeEdit = (row: any) => {
    console.log("row " + row);

    let path = `/Admin/masters/VehicleTypeEdit`;
    navigate(path, {
      state: row,
    });
  };
  const routeChangeAdd = () => {
    let path = `/Admin/masters/VehicleTypeAdd`;
    navigate(path);
  };
  let delete_id = "";
  const accept = () => {
    const collectData = {
      vehicleTypeId: delete_id
    };
    console.log("collectData " + JSON.stringify(collectData));
    api
      .delete(`VehicleType/DeleteEscrapVehicleType`, {
        headers: {
          'Content-Type': 'application/json',
          vehicleTypeId: delete_id,
        },
        data: {
          vehicleTypeId: delete_id,
        }
      })
      .then((response) => {
        if (response.data.status===1) {
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
        fetchvehicleData();
      });
  };


  const reject = () => {
    // toast.warn({summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    toast.warn("Rejected: You have rejected", { autoClose: 3000 });
  };

  const handledeleteClick = (del_id: any) => {
    console.log(del_id + " del_id ");
    delete_id = del_id;
    confirmDialog({
      message: "Do you want to delete this record ?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p=-button-danger",
      accept,
      reject,
    });
  };

  const fetchvehicleData = async () => {
    try {
      const collectData = {
        // "vehicleTypeId": -1,
        // "vehicleTypename": ""

        "orderby": "",
        "pageNo": 0,
        "pageSize": 0,
        "intnotnullvalue1": 0,
        "userId": "",
       
        "str1": "",
        "str2": "",
        "str3": "",
        "str4": "",
        "str5": "",
        "intvalue1": 0,
        "intvalue2": 0,
        "intvalue3": 0,
        "intvalue4": 0,
        "intnotnullvalue2": 0,
        "intnotnullvalue3": 0,
        "date1": "2024-11-19T06:19:58.663Z",
        "date2": "2024-11-19T06:19:58.663Z",
        "date3": "2024-11-19T06:19:58.663Z",
        "date4": "2024-11-19T06:19:58.663Z",
        "dec1": 0,
        "dec2": 0,
        "dec3": 0,
        "dec4": 0,
        "flag": true,
        "data": "",
        "success": true,
        "error": "",
        "selectPerindex": 0,
        "show": true
      };
      const response = await api.post(`VehicleType/GetEscrapVehicleType`, collectData);
      const data = response.data.data;
      console.log("🚀 ~ fetchvehicleData ~ response.data.data:", response.data.data)
      const vehicleWithIds = data.map((vehicle: any, index: any) => ({
        ...vehicle,
        serialNo: index + 1,
        id: vehicle.vehicleTypeId,
      }));
      setItem(vehicleWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "actions",
            headerClassName: "MuiDataGrid-colCell",
            headerName: t("text.Action"),
            width: 150,

            renderCell: (params) => {
              return [
                <Stack
                  spacing={1}
                  direction="row"
                  sx={{ alignItems: "center", marginTop: "5px" }}
                >
                  {/* {permissionData?.isEdit ? ( */}
                  <EditIcon
                    style={{
                      fontSize: "20px",
                      color: "blue",
                      cursor: "pointer",
                    }}
                    className="cursor-pointer"
                    onClick={() => routeChangeEdit(params.row)}
                  />
                  {/* ) : ( */}
                  {/* "" */}
                  {/* )} */}
                  {/* {permissionData?.isDel ? ( */}
                  <DeleteIcon
                    style={{
                      fontSize: "20px",
                      color: "red",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handledeleteClick(params.row.id);
                    }}
                  />
                </Stack>,
              ];
            },
          },

          // {
          //   field: "srno",
          //   headerName: t("text.SrNo"),
          //   flex: 1,
          //   headerClassName: "MuiDataGrid-colCell",
          // },
          {
            field: "vehicleTypename",
            headerName: t("text.VehicleTypeNames"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "vehicleCode",
            headerName: t("text.VehicleCodes"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            // renderCell(params) {
            //   return dayjs(params.row.mrnDate).format("DD-MMM-YYYY")
            // },
          },
          {
            field: "shortName",
            headerName: t("text.VehicleShortNames"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },


        ];
        setColumns(columns as any);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));


  return (
    <>
      <Card
        style={{
          width: "100%",
          // height: "100%",
          backgroundColor: "#E9FDEE",
          border: ".5px solid #FF7722 ",
          marginTop: "3vh"
        }}
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            "& .MuiDataGrid-colCell": {
              backgroundColor: `var(--grid-headerBackground)`,
              color: `var(--grid-headerColor)`,
              fontSize: 17,
              fontWeight: 900
            },
          }}
          style={{ padding: "10px", }}
        >
          <ConfirmDialog />

          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{ padding: "20px" }}
            align="left"
          >
            {t("text.VehicleTypes")}
          </Typography>
          <Divider />

          <Box height={10} />

          <Stack direction="row" spacing={2} classes="my-2 mb-2">
            {/* {permissionData?.isAdd == true && ( */}
            <Button
              onClick={routeChangeAdd}
              variant="contained"
              endIcon={<AddCircleIcon />}
              size="large"
              style={{ backgroundColor: `var(--header-background)` }}
            >
              {t("text.add")}
            </Button>
            {/* ) } */}

          </Stack>


          <DataGrids
            isLoading={isLoading}
            rows={item}
            columns={adjustedColumns}
            pageSizeOptions={[5, 10, 25, 50, 100]}
            initialPageSize={5}
          />
        </Paper>
      </Card>
      <ToastApp />

    </>
  );
}
